import { LoadingState } from '@komi-app/creator-ui'
import React from 'react'
import { Row, Spin } from 'antd'
import './Loading.scss'
import classNames from 'classnames'

interface IProps {
  size?: 'large' | 'default' | 'small'
  showFull?: boolean
  className?: string
  blur?: boolean
}

const Loading = ({
  size = 'default',
  blur,
  showFull = false,
  className = ''
}: IProps) => {
  const sz = size === 'default'
    ? 'medium'
    : size

  return (
    <Row
    className={classNames({
      loading: true,
      'loading--full': showFull,
      'loading--blur': blur,
      [className]: true
    })}
    justify="center"
    align="middle"
    >
      <LoadingState size={sz} type='wheel' />
      {/* <Spin size={size} /> */}
    </Row>
  )
}

export default Loading
